import * as React from 'react';
import './Footer.css';

class Footer extends React.Component {

    public render() {
        return (
            <footer>footer</footer>
        );
    }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/Footer/Footer.tsx